import { Chip, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"

export function EnabledChip({ enabled, enforced }) {
    return (
        <Stack spacing={0.25} alignItems="flex-start">
            <Chip size="small" variant="outlined" color={colour()} label={label()} />
            <If value={!!enforced}>
                <Typography variant="caption" color="text.secondary">
                    enforced
                </Typography>
            </If>
        </Stack>
    )

    function label() {
        return enabled ? "On" : "Off"
    }

    function colour() {
        return enabled ? "success" : "default"
    }
}
